import React, { Component } from "react";
import { connect } from "react-redux";
import DefaultProfile from "../../../../site_media/images/default-profile-pic-feeds.png";
import AxiosConfig from "axiosConfig";

class SingleNotification extends Component {
  setNotifiedOn = (d) => {
    const today = new Date();
    const createdAt = new Date(d);
    let diff = today.getTime() - createdAt.getTime();
    var days = Math.floor(diff / 1000 / 60 / 60 / 24);
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * (1000 * 60 * 60);
    var minutes = Math.floor(diff / 1000 / 60);
    diff -= minutes * (1000 * 60);
    if (days > 1) {
      return days + " days ago";
    }
    if (days > 0) {
      return days + " day ago";
    }
    if (hours > 1) {
      return hours + " hours ago";
    }
    if (hours > 0) {
      return hours + " hour ago";
    } else if (minutes <= 59 && minutes > 1) {
      return minutes + " minutes ago";
    } else if (minutes > 0) {
      return minutes + " minute ago";
    } else return "Few seconds ago";
  };
  onNotificationClick = (obj) => {
    AxiosConfig.get("/notifications/" + obj.props.ID + "/")
      .then(function (res) {
        if (res.data.status === "SUCCESS") {
          obj.props.isTargetBlank
            ? window.open(obj.props.buttonLink, "_blank")
            : window.location.assign(obj.props.buttonLink);
        }
      })
      .catch((err) => {
      });
  };
  render() {
    return (
      <div
        className="settings-dropdown__item notifications"
        onClick={() => this.onNotificationClick(this)}
      >
        <div className="notification-item">
          <img
            src={this.props.imgSrc || DefaultProfile}
            className="header_main_logo"
            alt="Katamundi Logo"
          />
          <h5 style={{ fontSize: "12px" }}>{this.props.label}</h5>
        </div>
        <h6>{this.setNotifiedOn(this.props.notifiedOn)}</h6>
        {!this.props.isRead ? <div className="new-item"></div> : null}
      </div>
    );
  }
}

export default connect()(SingleNotification);
